import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Injectable, Component, OnInit, ViewChild, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { serviceUrl } from '../common/serviceconstants';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmitterService } from '../emitterservice';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';import { Alert } from 'selenium-webdriver';
import { windowWhen } from 'rxjs-compat/operator/windowWhen';
;


@Component({
  selector: 'app-piechartgrid',
  templateUrl: './piechartgrid.component.html',
  styleUrls: ['./piechartgrid.component.scss']
})
export class PiechartgridComponent implements AfterViewInit {
  //displayedColumns: string[] = [ 'fruit','id'];
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  isadmin: any = false;
@Input() fyear="Total";
@Input() cgoalid="";
@Input() deptid="";
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private httpClient: GenericHttpClient,
    private http: HttpClient,
    private dialog: MatDialog) {
    let a = sessionStorage.getItem("Admin");
    if (a && a === "True") {
      this.isadmin = true;
    }
    this.GetNonProfitInvestmentTotals();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }


  displayedColumns: string[] = [];


  ngOnInit() {

    this.displayedColumns = [

      'communityGoal',
      'totalAmount'


    ];
   // this.FilterSource();
   

   EmitterService.get('cgoalid').subscribe(data => {
    this.cgoalid = data.cid;
    this.deptid=data.did;
   this.GetNonProfitInvestmentTotals();
  });
  EmitterService.get('deptid').subscribe(data => {
    this.cgoalid = data.cid;
    this.deptid=data.did;
    this.GetNonProfitInvestmentTotals();
   });
  }


  investmenttotalsmessage: any = '';

  GetNonProfitInvestmentTotals() {
    this.httpClient.get(serviceUrl + '/api/Community/GetNonProfitInvestmentTotals', {CommunityGoalID:this.cgoalid,DepartmentID:this.deptid}
    ).toPromise<any>().then(response => {
      //this.dataSource = new MatTableDataSource(response);
      this.investmenttotalsmessage ="";
      if (response.length > 0) {
        this.dataSource.data = response;
        //console.log(response)
      } else {
        this.dataSource.data = response;

        //this.investmenttotalsmessage = "No Information availble at this time. Please try again later."
        setTimeout(() => {
        alert("You must select one or more Community Goal(s).");
       // window.location.reload();
        },300);
        //this.investmenttotalsmessage = "";

      }
    });
  }

  filterYear(data: any[]): any[] {
    return data.filter(p => p.fiscalYear == this.fyear);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}







